import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Account, CustomProfileProperty } from 'app/back-office/account.model';
import { PeopleService } from '../people.service';
import { ProfileFieldEditingComponent } from './profile-field-editing/profile-field-editing.component';
import { TRIGGERBEE_LINK_HELP } from 'app/shared/utils/triggerbee-link-help';
import { SnackBarService } from 'app/core/snack-bar.service';
import { AccountAdminService } from 'app/back-office/account-admin.service';
import { AccountService } from 'app/account/account.service';
import { Subscription } from 'rxjs';
import { PageTitle } from 'app/shared/utils/page-title';

@Component({
  selector: 'app-contact-fields',
  templateUrl: './contact-fields.component.html',
  styleUrls: ['./contact-fields.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContactFieldsComponent implements OnInit, OnDestroy {
  @Input() pageTitle: string;
  public loading = false;
  public TRIGGERBEE_LINK_HELP = TRIGGERBEE_LINK_HELP;
  public dataProfileFields: CustomProfileProperty[] = [];
  public profileDataSource: MatTableDataSource<CustomProfileProperty>;
  public account: Account;
  private getAccountSub: Subscription;
  private subscriptionArray: Subscription[] = [];
  public PageTitle = PageTitle;

  public displayedColumns: string[] = ['name', 'mapTo', 'options'];
  constructor(
    public peopleService: PeopleService,
    private dialog: MatDialog,
    private snackbarService: SnackBarService,
    private accountAdminService: AccountAdminService,
    private accountService: AccountService,
  ) {}

  ngOnInit(): void {
    this.getDataCustomProfileProperty();
    this.getAccountSub = this.accountService.getCurrentAccount().subscribe((item: Account) => {
      this.account = item;
    });
  }

  public getDataCustomProfileProperty(): void {
    this.loading = true;
    this.peopleService.getProfileFields().subscribe(
      (items: CustomProfileProperty[]) => {
        if (items.length) {
          this.dataProfileFields = [...this.accountAdminService.staticProfileFields, ...items];
          this.buildAudienceTable(this.dataProfileFields);
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }

  public deleteContactField(id: number): void {
    this.peopleService.deleteProfileFields(id).subscribe(
      () => {
        const currentFieldId = this.dataProfileFields.findIndex((val) => val.id === id);
        if (currentFieldId !== -1) {
          this.dataProfileFields.splice(currentFieldId, 1);
          this.recreateDataFieldsSource();
        }
        this.snackbarService.success('people.profileFields.message.successDeleted');
      },
      () => {
        this.snackbarService.error('people.profileFields.message.errorDeleted');
      },
    );
  }

  public updatedContactField(value: CustomProfileProperty, isCreate: boolean): void {
    const dialogRef = this.dialog.open(ProfileFieldEditingComponent, {
      panelClass: 'profile-field-editing-dialog',
      autoFocus: false,
      data: {
        value,
        isCreate,
        allProfileFields: this.dataProfileFields,
      },
    });

    dialogRef.afterClosed().subscribe((result: CustomProfileProperty) => {
      if (result) {
        if (isCreate) {
          this.dataProfileFields.push(result);
        } else {
          const currentFieldId = this.dataProfileFields.findIndex((val) => val.id === result.id);
          if (currentFieldId !== -1) {
            this.dataProfileFields[currentFieldId] = result;
          }
        }
        this.recreateDataFieldsSource();
      }
    });
  }

  private recreateDataFieldsSource(): void {
    this.profileDataSource = new MatTableDataSource<CustomProfileProperty>(this.dataProfileFields);
  }

  private buildAudienceTable(profileFields: Array<CustomProfileProperty>): void {
    this.profileDataSource = new MatTableDataSource<CustomProfileProperty>(profileFields);
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.getAccountSub);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
